import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { Col } from 'react-bootstrap';
import StoreController from '@/controllers/StoreController';
import { IFooterLayoutProps, IFooterSections } from '@/domain/interfaces/IFooterSections';

import OptionFooter from '@/ui/containers/Footer/Columns/OptionFooter';
import ColumnWraper from '@/ui/containers/Footer/Columns/ColumnWraper';
import ContentModal from '@/ui/components/modals/ContentModal';


/** Componente Secciones de footer según configuración de la tienda */
const ColumnSections = (): JSX.Element => {

    /** Controlador tienda */
    const { getFooterSections } = StoreController();

    /** State con la configuración de columnas y secciones */
    const [footerLayout, setFooterLayout] = useState<IFooterLayoutProps[]>([]);
    /** State para activar el modal */
    const [showModal, setShowModal] = useState<boolean>(false);
    /** State con la info a mostrar en el modal  */
    const [activeSection, setActiveSection] = useState<IFooterSections | null>(null);

    /** Abre el modal o redirige a la ruta Blog */
    const openModal = (section: IFooterSections): void => {
        // Abre el modal sin cambiar la ruta
        setActiveSection(section);
        setShowModal(true);

    };

    /**Cierra el modal y limpia el state */
    const closeModal = (): void => {
        setShowModal(false);
        setActiveSection(null);
    };

    /** Trae la configuración de columnas/secciones del back */
    const getStoreFooterSections = async (): Promise<void> => {
        const footerRespose: IFooterLayoutProps[] = await getFooterSections();
        if (footerRespose) {
            setFooterLayout(footerRespose);
        }
    };

    useEffect(() => {
        getStoreFooterSections();
    }, []);

    /**  Contenido del modal */
    const SectionContentModal = (): JSX.Element => {
        const cleanHtml = DOMPurify.sanitize(activeSection?.content ?? '');
        return (
            <Col lg={12} className={'text-center'}>
                <div className={'text-secondary-2 text-justify '}
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
            </Col>


        );
    }

    /** Renderiza el componente principal */
    return (
        <>
            {footerLayout.map((column: IFooterLayoutProps, index) => (
                <ColumnWraper key={column.columnId + index} title={column.title}>
                    {column.sections.map((section: IFooterSections) => (
                        <div key={section.id} onClick={() => openModal(section)}>
                            <OptionFooter
                                title={section.title}
                            />
                        </div>
                    ))}
                </ColumnWraper>
            ))}
            {showModal &&
                <ContentModal
                    dialogClassName='modal-dialog-centered'
                    contentClassName='rounded-4 mh-400-px d-flex justify-content-between shadow border-0'
                    showModal={showModal}
                    message={activeSection?.title ?? ''}
                    contentColClass={9}
                    onClose={(closeModal)}
                    modalSize='xl'
                    isHalfModal={activeSection?.halfModal ?? false}
                    imageSrc={activeSection?.urlImage ?? ''}
                    imageAlt={activeSection?.title ?? ''}
                    classMessage='text-secondary-1 h1 text-center mt-4'
                    classContent='pt-3'
                    content={SectionContentModal()}
                />
            }
        </>
    );
}

export default ColumnSections;